import { Button } from "../../../components/common";
import BusinessCardGroupSlider from "../../../components/molecules/BusinessCardGroupSlider";
import { useTranslation } from "../../../i18n/I18nContext";
import { useLocalePath } from "../../../hooks/useLocalePath";
import { LANDING_MAX, LANDING_PAD_X } from "./landingLayout";

function rowSlice(items, rowIndex, len = 3) {
  if (!items?.length) return [];
  const out = [];
  const n = items.length;
  for (let i = 0; i < len; i++) {
    out.push(items[(rowIndex * len + i) % n]);
  }
  return out;
}

const ROWS = [
  { titleKey: "topPicks.title", subKey: "topPicks.subtext", iconSrc: "/icons/top-pick.svg" },
  { titleKey: "trending.title", subKey: "trending.subtext", iconSrc: "/icons/graph.svg" },
  { titleKey: "bestRated.title", subKey: "bestRated.subtext", iconSrc: "/icons/best_star.svg" },
];

/**
 * Three discovery bands matching Figma (Top picks, Trending, Best rated).
 */
export function LandingDiscovery({ items }) {
  const { t } = useTranslation();
  const lp = useLocalePath();

  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <div className="w-full bg-white pb-4 pt-2 sm:pb-6 lg:pb-8">
      {ROWS.map((row, idx) => {
        const slice = rowSlice(items, idx, 3);
        return (
          <section
            key={row.titleKey}
            aria-labelledby={`discovery-${idx}-title`}
            className={`${LANDING_MAX} ${LANDING_PAD_X} py-8 sm:py-10 lg:py-[50px]`}
          >
            <div className="mb-6 flex flex-col gap-4 sm:mb-8 lg:mb-10 lg:flex-row lg:items-start lg:justify-between">
              <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-start sm:gap-5 lg:gap-6">
                <img src={row.iconSrc} alt="" className="mx-auto h-14 w-14 shrink-0 sm:mx-0 sm:h-16 sm:w-16" aria-hidden />
                <div className="min-w-0 text-center sm:text-left">
                  <h2
                    id={`discovery-${idx}-title`}
                    className="font-bold text-[#1A265B] text-[26px] leading-tight sm:text-[32px] lg:text-4xl"
                  >
                    {t(row.titleKey)}
                  </h2>
                  <p className="mt-2 text-sm text-[#4B5563] sm:text-base">{t(row.subKey)}</p>
                </div>
              </div>
              <Button
                variant="outline-primary"
                label={t("viewMore")}
                icon="mdi:arrow-right"
                iconDirection="right"
                className="hidden shrink-0 rounded-[15px] lg:inline-flex"
                to={lp("/explore")}
              />
            </div>
            {hasItems ? (
              <BusinessCardGroupSlider items={slice} wrapperClassName="w-full py-0" />
            ) : (
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                {[0, 1, 2].map((n) => (
                  <div
                    key={n}
                    className="flex flex-col overflow-hidden rounded-[24px] border border-white/60 bg-white shadow-figma-card"
                  >
                    <div className="h-[200px] w-full animate-pulse bg-gradient-to-br from-frosted-blue to-soft-ice-blue" />
                    <div className="flex flex-1 flex-col gap-3 p-5">
                      <div className="h-4 w-3/4 animate-pulse rounded bg-frosted-blue" />
                      <div className="h-3 w-1/2 animate-pulse rounded bg-soft-ice-blue" />
                      <div className="h-3 w-full animate-pulse rounded bg-soft-ice-blue" />
                    </div>
                  </div>
                ))}
              </div>
            )}
            <Button
              variant="outline-primary"
              label={t("viewMore")}
              icon="mdi:arrow-right"
              iconDirection="right"
              className="mx-auto mt-4 rounded-[15px] lg:hidden"
              to={lp("/explore")}
            />
          </section>
        );
      })}
    </div>
  );
}
